import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/where-to-go/_components/Brands/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/where-to-go/_components/CategoriesList/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/where-to-go/_components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/where-to-go/_components/tags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(home)/where-to-go/_components/UpBtn.tsx");
